<div class="header-container">
  <!-- TOP ROW (Header 1st Row) -->
  <div class="header-top tableHeaderSurface">
    @for (item of headerLabels.TOP_HEADERS; track item.label) {
      <div class="top-header-item" [ngClass]="item.className" [style.grid-column]="item.column">
        <h2 class="mb-0">{{ item.label }}</h2>
      </div>
    }
  </div>

  <!-- COLUMN ROW (Header 2nd Row) -->
  <div class="column-header tableHeaderSurface">
    @for (column of headerLabels.COLUMN_HEADERS; track $index) {
      <div [class]="column.className">
        <h2 class="mb-0">{{ column.label }}</h2>
      </div>
    }
  </div>
</div>
